import axios from "axios";
import { takeLatest, call, put } from "redux-saga/effects";
import { createAction } from "redux-actions";
import { queryParams } from "../../../../utils/queryParams";

export const SET_LOADING = "saga/SET_LOADING";
export const FETCH_TABLE_DATA_SUCCESS = "saga/FETCH_TABLE_DATA_SUCCESS";
export const FETCH_TABLE_DATA = "saga/FETCH_TABLE_DATA";

const actionCreators = {
  getTableData: createAction(FETCH_TABLE_DATA)
};

export const { getTableData } = actionCreators;

export default function* watchCheckIn() {
  yield takeLatest(FETCH_TABLE_DATA, fetchTableData);
}

function* fetchTableData() {
  yield put({ type: SET_LOADING, payload: true });

  try {
    const response = yield call(
      axios.get,
      `${queryParams.apiVersion}admin/long_running_delayed_jobs`
    );

    yield put({ type: FETCH_TABLE_DATA_SUCCESS, payload: response.data });
    yield put({ type: SET_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}
